const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case "table.ocr_templates/SET_TABLE_PARAMS":
            return {
                ...state,
                ...action.params
            };
        case "table.ocr_templates/LIST_OCR_TEMPLATES_SUCCESS":
            return {
                ...state,
                data: action.response.data,
                filters: action.response.filters,
                ...action.response.pagination
            };
        default:
            return state;
    }
}
